export const OPEN_MF_STATUS = 'open_mf_status';
export const EXPAND_ORDER_DETAIL = 'expand_order_detail';
